import { Row, Col, Tooltip, Avatar, Typography } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';

const { Text } = Typography;

const ImageUrlCard = ({ thumb1000, handleRemoveImage }) => {
  return (
    <Row className='add-product-image-url-input__preview'>
      <Col style={{ position: 'relative' }}>
        <Tooltip title={thumb1000} color='#238dd9'>
          <Text ellipsis strong>
            {thumb1000}
          </Text>
        </Tooltip>
      </Col>
      <Col style={{ flex: 1, overflow: 'hidden' }}>
        <div className='add-product-image-url-input__image'>
          <Avatar
            className='add-product-image-url-input__image-avatar'
            shape='square'
            src={thumb1000}
          />
          <CloseCircleFilled
            className='add-product-image-url-input__image-delete'
            onClick={() => handleRemoveImage(thumb1000)}
          />
        </div>
      </Col>
    </Row>
  );
};

export default ImageUrlCard;
